// Configuração central de contato/suporte da plataforma FILA Gestão.
// Centralizada aqui para evitar hardcode duplicado em componentes.
// Pode ser sobreposta via env `REACT_APP_SUPPORT_WHATSAPP` sem alteração de código.
const RAW_PHONE = (process.env.REACT_APP_SUPPORT_WHATSAPP || "5591984848083").replace(/\D/g, "");

export const SUPPORT_WHATSAPP_NUMBER = RAW_PHONE;
export const SUPPORT_WHATSAPP_DISPLAY = "91 98484-8083";
export const SUPPORT_INSTAGRAM = "https://instagram.com/filagestao";
export const PLATFORM_NAME = "FILA Gestão";
export const PLATFORM_DEVELOPER = "Elite Tecnologia";

export function whatsappSupportUrl(message) {
  const msg = encodeURIComponent(
    message || "Olá, preciso de informações sobre o FILA Gestão.",
  );
  return `https://wa.me/${SUPPORT_WHATSAPP_NUMBER}?text=${msg}`;
}
